import React from 'react'
import slugify from 'react-slugify';
import { vuiDateDistance } from '@topkamera/viso-ui'
import { recentActionsMap } from 'containers/HomePage/constants'
import { getIncident } from 'api/incident'
import { filterByDateRange } from 'components/AskViso/utils'
import NotificationListPeriod from './NotificationListPeriod'
import './NotificationList.scss'

const NotificationList = ({
  list = [], markAsReadNotification, router, workspace, setNotificationList, onClose, unreadOnly
}) => {

  const mapNotifications = () => {
    let items = []
    list.forEach((item) => {
      const getCategoryDetails = recentActionsMap[item.category]
      items.push({
        captions: [getCategoryDetails?.label || item.category],
        icon: getCategoryDetails?.icon || 'timeSync',
        showIndicator: !item.readState,
        timeStamp: item.createdAt && vuiDateDistance({ date: item.createdAt }),
        createdAt: item.createdAt,
        itemData: item,
        url: getCategoryDetails?.url
      })
    })
    return items
  }

  const { today = [], yesterday = [], previous7Days = [], previous30Days = [], older = [] } = filterByDateRange(mapNotifications())
  const earlierItems = [...previous7Days, ...previous30Days, ...older]

  const onNotificationClick = async (id) => {
    onMarkAsRead(id)
    const findNotification = list.find((item) => item._id === id)
    if (findNotification) {
      const getCategoryDetails = recentActionsMap[findNotification?.category]
      const isRemoveAction = findNotification?.message?.includes('removed.')
      if (isRemoveAction) return null

      if (findNotification?.category === 'incident' && findNotification?.resourceId) {
        const incidentData = await getIncident({ id: findNotification.resourceId })
        const incident = incidentData?.data?.data?.incident

        if (incident?._id && incident?.incidentBoardId) {
          onClose()
          return router.navigate(`/${slugify(workspace.name)}/${getCategoryDetails.url}/${incident.incidentBoardId}/${incident._id}`)
        }
      }

      if (getCategoryDetails?.noIdPage) {
        router.navigate(`/${slugify(workspace.name)}/${getCategoryDetails.url}`)
      } else if (getCategoryDetails?.url) {
        router.navigate(`/${slugify(workspace.name)}/${getCategoryDetails.url}/${findNotification.resourceId}`)
      }
    }
  }

  const onMarkAsRead = (id) => {
    markAsReadNotification({ id })
    let updateRead = []
    if (unreadOnly) {
      updateRead = list.filter((item) => item._id !== id)
    } else {
      updateRead = list.map((item) => item._id === id ? { ...item, readState: true } : item)
    }
    setNotificationList(updateRead)
  }

  const mapAccent = () => {
    const accents = ['accent0', 'accent1', 'accent2']
    const visiblePeriods = [
      { key: 'today', items: today },
      { key: 'yesterday', items: yesterday },
      { key: 'earlier', items: earlierItems }
    ].filter(({ items }) => items.length > 0)

    return visiblePeriods.reduce((acc, { key }, idx) => {
      acc[key] = accents[idx] || accents[accents.length - 1]
      return acc
    }, {})
  }

  const accentByPeriod = mapAccent()

  return (
    <div className='vui-flex vui-flex-column vui-gap-20 viso-notification-list'>
      <NotificationListPeriod
        items={today}
        color={accentByPeriod.today}
        onClick={onNotificationClick}
        onIndicatorClick={onMarkAsRead}
        title='Today'
      />
      <NotificationListPeriod
        items={yesterday}
        color={accentByPeriod.yesterday}
        onClick={onNotificationClick}
        onIndicatorClick={onMarkAsRead}
        title='Yesterday'
      />
      <NotificationListPeriod
        items={earlierItems}
        color={accentByPeriod.earlier}
        onClick={onNotificationClick}
        onIndicatorClick={onMarkAsRead}
        title='Earlier'
      />
    </div>
  )
}

export default NotificationList